import { FeedbackSentiment } from "@/api/types";
import { Box } from "@chakra-ui/react";
import React from "react";
import { FaThumbsDown, FaThumbsUp } from "react-icons/fa6";

interface Props {
  type: FeedbackSentiment;
  isActive?: boolean;
  onClick?: () => void;
}

export const FeedbackIcon = ({ type, isActive, onClick }: Props) => {
  return (
    <Box
      color={isActive ? "primary" : "white"}
      borderRadius="50%"
      borderWidth="2px"
      borderColor="white"
      bg={isActive ? "white" : "transparent"}
      p="5"
      _hover={{ bg: "white", color: "primary" }}
      _active={{ transform: "scale(0.95)" }}
      cursor="pointer"
      onClick={onClick}
    >
      {type === FeedbackSentiment.ThumbsUp && <FaThumbsUp size="38" />}
      {type === FeedbackSentiment.ThumbsDown && <FaThumbsDown size="38" />}
    </Box>
  );
};
